import { ChangeDetectionStrategy, Component, inject } from '@angular/core'

import { FlxColourSwatchDirective } from '@flowx/designer/shared/directives/colour-swatch.directive'

import { FlxThemeColorService } from '../color.service'

@Component({
  selector: 'flx-theme-colors-renderer',
  imports: [FlxColourSwatchDirective],
  templateUrl: './theme-colors-renderer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./theme-colors-renderer.component.scss'],
})
export class FlxThemeColorsRendererComponent {
  readonly colors = inject(FlxThemeColorService).renderData
}
